var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1261158253"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M31.12 28.6035H0.879976C0.533501 28.6035 0.25 28.8807 0.25 29.2335V31.1235C0.25 31.47 0.533501 31.7535 0.879976 31.7535H31.12C31.4665 31.7535 31.75 31.47 31.75 31.1235V29.2335C31.75 28.8807 31.4665 28.6035 31.12 28.6035Z",
    fill: "#2EBB49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M31.3657 6.59527L16.2457 0.295278C16.0882 0.232303 15.9118 0.232303 15.7606 0.295278L0.640635 6.59527C0.407505 6.6961 0.25 6.92288 0.25 7.18118V9.0712C0.25 9.41772 0.533501 9.70117 0.879976 9.70117H31.12C31.4665 9.70117 31.75 9.41772 31.75 9.0712V7.18118C31.75 6.92288 31.5988 6.6961 31.3657 6.59527Z",
    fill: "#2EBB49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M24.0519 25.5537C23.7054 25.5537 23.4219 25.8372 23.4219 26.1837V27.3429H30.3015V26.1837C30.3015 25.8372 30.0179 25.5537 29.6714 25.5537H29.136V12.7458H29.6714C30.0179 12.7458 30.3015 12.4623 30.3015 12.1158V10.9629H23.4219V12.1158C23.4219 12.4623 23.7054 12.7458 24.0519 12.7458H24.5811V25.5537H24.0519Z",
    fill: "#2EBB49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M3.43857 25.5537C3.09209 25.5537 2.80859 25.8372 2.80859 26.1837V27.3429H9.68819V26.1837C9.68819 25.8372 9.40469 25.5537 9.05821 25.5537H8.52898V12.7458H9.05821C9.40469 12.7458 9.68819 12.4623 9.68819 12.1158V10.9629H2.80859V12.1158C2.80859 12.4623 3.09209 12.7458 3.43857 12.7458H3.9678V25.5537H3.43857Z",
    fill: "#2EBB49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M13.7433 25.5537C13.3968 25.5537 13.1133 25.8372 13.1133 26.1837V27.3429H19.9929V26.1837C19.9929 25.8372 19.7094 25.5537 19.3629 25.5537H18.8337V12.7458H19.3629C19.7094 12.7458 19.9929 12.4623 19.9929 12.1158V10.9629H13.1133V12.1158C13.1133 12.4623 13.3968 12.7458 13.7433 12.7458H14.2724V25.5537H13.7433Z",
    fill: "#2EBB49"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.9da34ea954572044f20b888fe5cbec0c.svg";
export { ForwardRef as ReactComponent };